import { render, staticRenderFns } from "./CascaderFacet.vue?vue&type=template&id=34b287e9&scoped=true"
import script from "./CascaderFacet.vue?vue&type=script&lang=js"
export * from "./CascaderFacet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b287e9",
  null
  
)

export default component.exports